export const HOME_ROUTE = '/';
export const DASHBOARD = '/dashboard';
export const NOTIFICATIONS = '/notifications';
export const ALL_EMPLOYEES = '/all-employees';
export const PROJECTS = '/projects';
export const ALL_PROJECTS = '/projects';
export const SINGLE_PROJECT = '/projects/:id';
export const NOT_FOUND = '*';
export const PENDING_ACTIONS = '/pending-actions';
export const RESOURCE_ALLOCATIONS = '/resource-allocations';
export const ALL_RESOURCE_ALLOCATIONS = '/resource-allocations';
export const SINGLE_RESOURCE_ALLOCATIONS = '/resource-allocations/:id';
export const TOOLS_AND_TECHNOLOGIES = '/tools-technologies';
export const USERS = '/users';
